// File: apps/web/src/components/layout/Layout.tsx

import { ReactNode } from 'react';
import { Navbar } from './Navbar';
import { Sidebar } from './Sidebar';
import { Footer } from './Footer';
import { useAuthStore } from '../../stores/auth.store';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { isAuthenticated } = useAuthStore();

  return (
    <div className="min-h-screen bg-neutral-900 flex flex-col">
      <Navbar />
      <Sidebar />
      <main className={`pt-16 flex-1 ${isAuthenticated ? 'lg:pl-64' : ''}`}>
        {children}
      </main>
      <Footer />
    </div>
  );
}
